import { Component, computed, inject, Input, input, OnInit } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormatPhonePipe } from '@shared/pipes';
import { CurrencyPipe, DatePipe, NgClass, NgIf } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { Order } from '@app/resources/services';
import { PortalTheme } from '@app/@shared/models';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';

@Component({
  selector: 'app-existing-transaction-basic-details',
  standalone: true,
  imports: [FaIconComponent, FormatPhonePipe, NgIf, PanelModule, CurrencyPipe, DatePipe, NgClass],
  templateUrl: './existing-transaction-basic-details.component.html',
  styleUrl: './existing-transaction-basic-details.component.scss',
})
export class ExistingTransactionBasicDetailsComponent implements OnInit {
  private readonly cssValidatorService = inject(CssValidatorService);
  transaction = input.required<Order>();
  @Input() theme: PortalTheme | undefined;

  employee = computed(() => {
    const transaction = this.transaction();
    if (transaction.OriginSDK) {
      return transaction.EmployeeId ? `EMPLOYEE #${transaction.EmployeeId}` : 'EMPLOYEE';
    }
    const employee = transaction.Employee;
    return employee ? `${employee.NameFirst} ${employee.NameLast}` : 'EMPLOYEE';
  });

  protected isMember: boolean = false;

  ngOnInit(): void {
    this.isMember = this.transaction().OrderPayments.some(
      (orderPayment) => orderPayment.ConsumerId != null && orderPayment.ConsumerId !== 0
    );
    this.setCSSCustomProperties();
  }

  protected getReviewBadge(score?: number | null): { value: string; cssClass: string } {
    if (score === 5) {
      return { value: 'Great', cssClass: 'transactions-great' };
    } else if (score === 0 || score === 1) {
      return { value: 'Poor', cssClass: 'transactions-poor' };
    } else if (score === undefined) {
      return { value: '', cssClass: 'rating-skeleton skeleton' };
    } else if (score === null && this.isMember) {
      return { value: 'Not Answered', cssClass: 'transactions-not-answered' };
    } else {
      return { value: '', cssClass: '' };
    }
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties based on the theme
      document.documentElement.style.setProperty('--primary', this.theme.primary);
      document.documentElement.style.setProperty(
        '--table-bg-status-secondary',
        this.theme.table.statusColors.secondary
      );
      document.documentElement.style.setProperty('--table-bg-status-danger', this.theme.table.statusColors.danger);
      document.documentElement.style.setProperty('--table-bg-status-primary', this.theme.table.statusColors.primary);

      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('ExistingTransactionBasicDetailsComponent');
    }
  }
}
